(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("NZ-Bank-Account-Validator", [], factory);
	else if(typeof exports === 'object')
		exports["NZ-Bank-Account-Validator"] = factory();
	else
		root["NZ-Bank-Account-Validator"] = factory();
})(this, function() {
return 


/** WEBPACK FOOTER **
 ** webpack/universalModuleDefinition
 **/